import { Entry } from "contentful";
import { ContentBlock, GuideContainer, GuideTypes, Metadata } from "../models";
import { createIntroHeader } from "./IntroHeaderFactory";
import { createEstimatedTimeHeader } from "./EstimatedTimeHeaderFactory";
import { createGuideContent } from "./GuideContentFactory";
import { UserContextValues } from "../types";

export const createGuide = (
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
  userContextValues?: UserContextValues,
): GuideContainer => ({
  introHeader: createIntroHeader(entries, guideType, userContextValues),
  estimatedTimeHeader: createEstimatedTimeHeader(entries, guideType),
  content: createGuideContent(entries, guideType, userContextValues),
});
